import { render } from "./RotasTable.vue?vue&type=template&id=40dad5ce&ts=true"
import script from "./RotasTable.vue?vue&type=script&lang=ts"
export * from "./RotasTable.vue?vue&type=script&lang=ts"

import "./RotasTable.vue?vue&type=style&index=0&id=40dad5ce&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__